/**
 * Any constant global values can be defined here.
 */


export const BrandList = Object.freeze({
  AIE: { id: 1, text: 'Academic Institute of Excellence (AIE)' },
  GDC: { id: 13, text: 'Greenside Design Center (GDC)' },
  LF: { id: 24, text: 'LearnFast' },
  EMI: { id: 28, text: 'Emendy Multimedia Institute' },
  CAD: { id: 35, text: 'The CAD Corporation' },

  NONE: { text: '-' }
});

export const initFilter = { arr: [], checkObj: {} };
